"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../../Types");
var React = require("react");
var Util_1 = require("../../Services/Util");
var EventHandlerService_1 = require("../../Services/EventHandlerService");
var reactstrap_1 = require("reactstrap");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
exports.UprcWarningEvent = function (resources, uprc) { return new Types_1.VeriLiteWarningEvent(React.createElement(UprcWarningEventContent, { resources: resources, uprc: uprc }), resources.Warning, [
    new Types_1.VeriLiteEventAction(resources.CopyUPRC, "primary", function (currentEvent, closeModalCallback) {
        Util_1.copyText(uprc);
        currentEvent.actions = [
            new Types_1.VeriLiteEventAction(resources.CopiedToClipboard, "success", function (currentEvent, closeModalCallback) {
            }),
            new Types_1.VeriLiteEventAction(resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                closeModalCallback();
            })
        ];
        EventHandlerService_1.EventHandlerProvider.GetInstance().UpdateEvent();
    }),
    new Types_1.VeriLiteEventAction(resources.Close, "secondary", function (currentEvent, closeModalCallback) {
        closeModalCallback();
    })
]); };
var UprcWarningEventContent = function (props) {
    return React.createElement(reactstrap_1.Row, null,
        React.createElement(reactstrap_1.Col, { md: "auto" },
            React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "4x", className: "text-danger", icon: free_solid_svg_icons_1.faExclamationCircle })),
        React.createElement(reactstrap_1.Col, { className: "fv-c", style: { whiteSpace: "pre-line" } }, props.resources.AnAlertHasBeenRaised + " \n " + props.resources.UPRC + ": " + props.uprc));
};
//# sourceMappingURL=UprcWarningEvent.js.map